import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import SchoolLogo from "../components/SchoolLogo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(identifier, password);
      toast.success(`Welcome, ${u.name}`);
      if (u.role === "super_admin") nav("/super");
      else if (u.role === "org_admin") nav("/org");
      else nav("/member");
    } catch (e) {
      toast.error(e.message || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-white grid place-items-center p-6">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center text-center mb-8">
          <SchoolLogo size={140} />
          <div className="mt-5 text-[10px] font-bold uppercase tracking-[0.22em] text-[#05126E]">
            Attendance System
          </div>
          <h1 className="mt-2 text-xl sm:text-2xl font-extrabold tracking-tight text-[#0f1a14]">
            GANAP INC.
          </h1>
        </div>

        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <label className="text-xs font-semibold tracking-wider text-[#0f1a14]">
              Email or Member ID
            </label>
            <input
              type="text"
              required
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              className="mt-1 w-full px-3 py-2.5 rounded-md border border-[#D2D8D4] bg-white outline-none focus:border-[#05126E] focus:ring-2 focus:ring-[#05126E]/20"
              data-testid="email-input"
            />
          </div>
          <div>
            <label className="text-xs font-semibold tracking-wider text-[#0f1a14]">
              Password
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full px-3 py-2.5 rounded-md border border-[#D2D8D4] bg-white outline-none focus:border-[#05126E] focus:ring-2 focus:ring-[#05126E]/20"
              data-testid="password-input"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            className="w-full py-3 rounded-md bg-[#05126E] hover:bg-[#030B45] disabled:opacity-60 text-white font-semibold flex items-center justify-center gap-2 transition-colors"
            data-testid="login-submit-btn"
          >
            {busy && <Loader2 className="w-4 h-4 animate-spin" />}
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
